import React, { useState } from "react";
import "styles/pages/page-shop.scss";

import Layout from "components/Layout";
import ScrollTile from "components/ScrollTile/ScrollTile";
import Seo from "components/Seo";
import SubpageHeader from "components/SubpageHeader/SubpageHeader";
import TeamPersonTile from "components/TeamPersonTile/TeamPersonTile";
import SectionHeader from "components/SectionHeader/SectionHeader";
import ContactForm from "../components/ContactForm/ContactForm";

const ShopPage = ({ pageContext }) => {
  const [recipient, setRecipient] = useState("");
  const pageContent = pageContext.pageContent;
  const seo = pageContext.seo;
  const team = pageContext.pageContent.shopTeam;
  const onReset = () => {
    setRecipient("");
  };
  return (
    <Layout>
      <Seo title={seo.title} description={seo.metaDesc} />
      <SubpageHeader
        title={pageContent.mainTitle}
        subtitle={pageContent.subtitle}
        location={pageContext.title}
        crumbFirstLabel="serwis części i akcesoria"
      />
      <section className="shop-about">
        <div className="container">
          <div
            className="shop-about__text"
            dangerouslySetInnerHTML={{ __html: pageContent.desc }}
          />
          <div className="row justify-content-center">
            <div className="col-xl-4 col-sm-6">
              <ScrollTile
                title="Udzielimy informacji i doradzimy najlepsze rozwiązania!"
                icon={require("assets/icons/team-support.svg").default}
                anchor="kontakt"
                buttonText="Skontaktuj się z działem akcesoriów"
                shadow={false}
                contact={true}
              />
            </div>
          </div>
        </div>
      </section>
      <span className="anchor" id="kontakt"></span>
      <section className="shop-team">
        <div className="container">
          <SectionHeader
            subtitle="NASZ ZESPÓŁ"
            title="Sklep i akcesoria karawaningowe"
            reversed={true}
          />
          <div className="row justify-content-center">
            {team?.map((person, index) => {
              return (
                <div className="col-xl-3 col-md-4 col-sm-6" key={index}>
                  <TeamPersonTile
                    name={person.singleTeam.fullname}
                    jobName={person.singleTeam.jobname}
                    avatar={person.singleTeam.avatar?.sourceUrl}
                    phone={person.singleTeam.phone}
                    email={person.singleTeam.email}
                    onClick={(e) => setRecipient(person.singleTeam.email)}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </section>
      <span className="anchor" id="formularz"></span>
      <section className="shop-contact">
        <ContactForm
          subject="SKLEP I AKCESORIA KARAWANINGOWE"
          selectedEmail={recipient}
          onReset={onReset}
        />
      </section>
    </Layout>
  );
};

export default ShopPage;
